import React, { useState, useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
import ModalScreen from "./ModalScreen";
import MenuScreen from "./MenuScreen";
import MyProfile from "./MyProfile";
import { fetchContent } from "../services/api";
import EditProfile from "./EditProfile";
import DeleteProfile from "./DeleteProfile";
import UpdateProfile from "./UpdateProfile";
import HomeScreen from "./HomeScreen";
import selectedIcon from "../assets/selectedIcon.png";
import { Translate, Languages } from "./LanguageChanger";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import backIcon from "../assets/back-button.png";
import Wrapper from "./shared/Wrapper";
import {
  getUserProfile,
  logoutUser,
  updateUserProfile,
} from "../services/services";
import AuthFailModal from "./AuthFailModal";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

// const ToggleSwitch = React.forwardRef(
//   ({ isChecked, onChange, focused }, ref) => {
//     return (
//       <label>
//         <input
//           type="checkbox"
//           checked={isChecked}
//           onChange={onChange}
//           ref={ref}
//           className={focused ? "focused" : ""}
//           style={{
//             width: "26px",
//             height: "26px",
//             position: "relative",
//             left: "0rem",
//           }}
//         />
//         {/* Optional label for the checkbox */}
//       </label>
//     );
//   }
// );

const ToggleSwitch = React.forwardRef(
  ({ isChecked, onChange, focused = true }, ref) => {
    console.log(focused, "focused");
    return (
      <label
        className="toggle-switch"
        style={{
          position: "relative",
          display: "inline-block",
          width: "34.45px",
          height: "18.67px",
          marginTop: "5px",
        }}
      >
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          ref={ref}
          className={focused ? "focused" : ""}
          style={{
            opacity: 0,
            width: 0,
            height: 0,
            position: "absolute",
          }}
        />
        <span
          className="slider"
          style={{
            position: "absolute",
            cursor: "pointer",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: isChecked ? "#ff4eb7" : "#383838",
            transition: ".4s",
            borderRadius: "34px",
          }}
        >
          <span
            className="slider-knob"
            style={{
              position: "absolute",
              content: "",
              height: "24.03px",
              width: "24.03px",
              left: isChecked ? "20px" : "-4px",
              bottom: "-2.6px",
              backgroundColor: !isChecked ? "#bab6b6 " : "#EC008C",
              transition: ".4s",
              borderRadius: "50%",
            }}
          />
        </span>
      </label>
    );
  }
);

const AddProfile = ({ navigate, isLogedIn }) => {
  const [loading, setLoading] = useState(false);
  const lang = localStorage.getItem("AppLanguage");
  const [selectedLanguage, setSelectedLanguage] = useState(lang);
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  const handleInputFocus = () => {
    if (!inputRef.current.readOnly) {
      setKeyboardOpen(true);
    }
  };
  const handleInputBlur = () => {
    setKeyboardOpen(false);
  };

  const [name, setName] = useState("");
  const [isKidsProfile, setIsKidsProfile] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isFirstDownPress, setIsFirstDownPress] = useState(true); // Track first down arrow press
  const [confirmedSelection, setConfirmedSelection] = useState(null);
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [changeScreen, setChangeScreen] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [isAvatarSelected, setIsAvatarSelected] = useState(false);
  const [isAddButtonVisible, setIsAddButtonVisible] = useState(true);

  const hasLoadedRef = useRef(false);

  useEffect(() => {
    console.log("selectedIndex", selectedIndex);
  }, [selectedIndex]);

  const [state, setStateName] = useState({
    isAddButton: false,
    isToggleButtonSelected: false,
    isUserInputBoxSelected: false,
    shouldCloseMenu: true,
    shouldShowModal: false,
    shouldShowAuthModal: false,
    isBackButtonSelected: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
  });
  const {
    isAddButton,
    isToggleButtonSelected,
    isUserInputBoxSelected,
    isBackButtonSelected,
    shouldCloseMenu,
    shouldShowModal,
    shouldShowAuthModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
  } = state;

  const handleNameChange = (e) => {
    const inputValue = e.target.value;

    // Regex: Start with alphabet, followed by alphabets, numbers, spaces, or special characters
    const validNameRegex =
      /^[a-zA-Z][a-zA-Z0-9\s!@#$%^&*()_+={}[\]:;"'<>,.?/-]*$/;

    if (inputValue === "" || validNameRegex.test(inputValue)) {
      setName(inputValue);
      setErrorMessage(""); // Clear error
    } else {
      setErrorMessage("Username should start with an alphabet.");
    }
  };

  const getTranslation = (key) => {
    return Languages[selectedLanguage]?.[key] || Languages.English[key];
  };

  // const [screen, setScreen] = useState("AddProfile");
  // const [data, setData] = useState({});

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    // setData(data);
    window.removeEventListener("keydown", AddProfileKeyHandler);
    // window.addEventListener("keydown", AddProfileKeyHandler);
  };

  const masterData = JSON.parse(localStorage.getItem("masterData")) || [];
  // const myprofile = masterData.data?.avatar || [];
  const myprofile = (masterData.data?.avatar || []).slice(0, 10);

  let user_details = JSON.parse(
    localStorage.getItem("user_details")
  ).user_profiles;
  // const user_profile = JSON.parse(user_details);

  const updatedMyprofile = localStorage.getItem("updateMyProfile")
    ? JSON.parse(localStorage.getItem("updateMyProfile")).data
    : null;

  // const user_profile = updatedMyprofile ? updatedMyprofile.data : user_details.user_profiles;

  const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  // const myprofile = (masterData.data?.avatar || []).slice(0, 10);

  // const updatedMyprofile = JSON.parse(localStorage.getItem("updateMyProfile")).data;

  // const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  //   const updatedMyprofile = localStorage.getItem("updateMyProfile")
  //   ? JSON.parse(localStorage.getItem("updateMyProfile")).data
  //   : null;

  // // If updated profile is present, use it; otherwise, fall back to user_details
  // const user_profile = updatedMyprofile && updatedMyprofile.length > 0
  //   ? updatedMyprofile
  //   : user_details;

  const [profiles, setProfiles] = useState(
    user_profile.map((profile) => ({
      name: profile.username,
      image: profile.profile,
      isKids: profile.is_kid,
      profileId: profile.profile_id,
    }))
  );

  const avatarRefs = useRef([]);
  const inputRef = useRef(null);
  const toggleRef = useRef(null);
  const buttonRef = useRef(null);
  const backButtonRef = useRef(null); // Ref added for Back Button focus

  const AddProfileKeyHandler = (event) => {
    switch (event.keyCode) {
      case 13: // Enter key
        if (isBackButtonSelected) {
          handleBackButton();
          return;
        }

        if (selectedIndex < myprofile.length) {
          localStorage.setItem("selectedAddProfile", JSON.stringify(myprofile[selectedIndex]));
          setConfirmedSelection(selectedIndex);
        } else if (selectedIndex === 12) {
           // Add Button Logic
           handleOk();
        } else if (selectedIndex === 11) {
          // Toggle the checkbox when it is focused
          setIsKidsProfile((prev) => !prev);
        }
        break;

      case 39: // Right arrow
        if (!isBackButtonSelected && selectedIndex < myprofile.length - 1) {
          setSelectedIndex((prevIndex) => prevIndex + 1);
        }
        break;

      case 37: // Left arrow
        if (!isBackButtonSelected && selectedIndex > 0) {
          setSelectedIndex((prevIndex) => prevIndex - 1);
        }
        break;

      case 38: // Up arrow
        if (!isBackButtonSelected) {
          if (selectedIndex > 4 && selectedIndex < myprofile.length) {
            setSelectedIndex((prevIndex) => prevIndex - 5); 
          } 
          else if (selectedIndex >= 0 && selectedIndex <= 4) {
            setStateName((prevState) => ({
              ...prevState,
              isBackButtonSelected: true,
            }));
            setSelectedIndex(-1);
            if (backButtonRef.current) backButtonRef.current.focus();
          } 
          else if (selectedIndex === myprofile.length) {
            setSelectedIndex(myprofile.length - 1);
          } else if (selectedIndex === myprofile.length + 1) {
          // Move from Add button to the toggle button (checkbox)
            setSelectedIndex(myprofile.length);
            if(toggleRef.current) toggleRef.current.focus();
          } else if (selectedIndex === myprofile.length + 2) {
          // Move from Add button to input field, skip the toggle button
            setSelectedIndex(myprofile.length + 1);
          }
        }
        break;

      case 40: // Down arrow
        if (isBackButtonSelected) {
          setStateName((prevState) => ({
            ...prevState,
            isBackButtonSelected: false,
          }));
          setSelectedIndex(0);
          return;
        }
        if (selectedIndex < myprofile.length - 5) {
          setSelectedIndex((prevIndex) => prevIndex + 5); // Navigate avatars down
        } else if (
          selectedIndex >= myprofile.length - 5 &&
          selectedIndex < myprofile.length
        ) {
          // Move from avatar to input field
          setSelectedIndex(myprofile.length);
        } else if (selectedIndex === myprofile.length) {
          // Move from input field to Add button, skip the toggle button
          setSelectedIndex(myprofile.length + 1);
        } else if (selectedIndex === myprofile.length + 1) {
          // Move from input field to Add button, skip the toggle button
          setSelectedIndex(myprofile.length + 2);
        }
        break;

      case 461: // Back key
      // case 8: // Backspace
      case 10009: // Return key
        handleBackButton();
        break;

      default:
        break;
    }
  };

  const handleOk = () => {
    console.log("selectedIndex...", selectedIndex);
    const showError = (message) => {
      setErrorMessage(message);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    };

    if (!isAvatarSelected) {
      let isAvatar = <Translate langKey={"choose_avatar"} />;
      showError(isAvatar);
      return;
    }
    if (!name) {
      let isName = <Translate langKey={"enter_name"} />;
      showError(isName);
      return;
    }
    if (!hasLoadedRef.current) {
      setIsAddButtonVisible(false); // hide the Add button immediately
      loadData();
      hasLoadedRef.current = true;
      console.log(hasLoadedRef, "loadData called");
    }
    // loadData();
    // if (selectedIndex < myprofile.length) {
    //   localStorage.setItem(
    //     "selectedAddProfile",
    //     JSON.stringify(myprofile[selectedIndex])
    //   );
    //   setConfirmedSelection(selectedIndex);
    // } else if (selectedIndex === 12) {
    //   if (!JSON.parse(localStorage.getItem("selectedAddProfile"))) {
    //     setErrorMessage("Please select a profile image first.");

    //     // Set timeout to clear the error message after 10 seconds
    //     setTimeout(() => {
    //       setErrorMessage("");
    //     }, 10000);

    //     return; // Stop further execution if no profile is selected
    //   } else {
    //     loadData(); // Continue with loading data if a profile is selected
    //   }
    // } else if (selectedIndex === 11) {
    //   // Toggle the checkbox when it is focused
    //   setIsKidsProfile((prev) => !prev);
    // }
  };

  const avatarSeclection = (index) => {
    if (index < myprofile.length) {
      localStorage.setItem(
        "selectedAddProfile",
        JSON.stringify(myprofile[index])
      );
      setConfirmedSelection(index);
    }
  };

  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        localStorage.removeItem("user_details");
        localStorage.removeItem("userId");
        localStorage.removeItem("profileId");
        navigate("LoginScreen");
        break;
      case "Logout":
        // localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        const getCountry = localStorage.getItem("country");
        let headers = {
          iskid: "0",
          Langid: "1",
          "Content-Type": "application/json",
          country: getCountry,
        };
        // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
        logoutUser();
        localStorage.clear();
        window.appReload();
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;
      default:
        break;
    }
  };
  const modalCANCELButtonHandler = () => {
    MenuScreen.ReseTfocus(-1);
    setStateName((prevState) => ({
      ...prevState,
      shouldShowModal: false,
      shouldFocusToRowList: true,
    }));
  };

  const handleExit = () => {
    setStateName((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Exit", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleBackButton = () => {
    window.removeEventListener("keydown", AddProfileKeyHandler);
    navigate("ProfileScreen");
  };

  const handleLogout = (p) => {
    setStateName((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleAuthFailLogout = (p) => {
    console.log("handleAuthFailLogout......");
    setStateName((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: false,
      shouldShowAuthModal: true,
      // errTitle: "Session-Expired",
      errDescription: "session-desc",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login"],
    }));
    MenuScreen.SetFocus(true);
  };

  const loadData = async () => {
    const showError = (message) => {
        setErrorMessage(message);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    };
    if (!isAvatarSelected) {
      let isAvatar = <Translate langKey={"choose_avatar"} />;
      showError(isAvatar);
      return;
    }
    if (!name) {
      let isName = <Translate langKey={"enter_name"} />;
      showError(isName);
      return;
    }
    const getCountry = localStorage.getItem("country");

    let myHeaders = {
      platform: "0",
      iskid: "0",
      // age: "12",
      country: getCountry,
      Langid: "1",

      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][0]["profile_id"],
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    const profile_img = JSON.parse(localStorage.getItem("selectedAddProfile"));
    const isKidEnable = isKidsProfile ? 1 : 0;

    const raw = {
      profile_id: "",
      activity: 1,
      username: name,
      profile: profile_img.url,
      is_kid: isKidEnable,
    };

    let body = JSON.stringify(raw);

    setStateName((prevState) => ({
      ...prevState,
      isAddButton: false,
    }));

    try {
      // const [response] = await Promise.all([
      //   fetchContent("/V1/updateUserProfile", "POST", myHeaders, body),
      // ]);

      const response = await updateUserProfile(raw, myHeaders);

      setStateName((prevState) => ({
        ...prevState,
        isAddButton: false,
      }));

      window.initialCall = false

      console.log("response....", response);

      if (!response.success && response.status === null) {
        handleAuthFailLogout();
      }

      let profileName = response?.data?.[0]?.username;
      let profileType = response?.data?.[0]?.is_kid === 0 ? "Adult" : "Child";

      console.log(profileName, profileType, "profileInfo");

      // Matomo Event
      sendTestMatomoEvent({
        eventCategory: "Profile",
        eventAction: "Add",
        eventName: `${profileName}/${profileType}`,
        url: "profile",
      });

      let updateProfile = <Translate langKey={"added_profile"} />;
      setErrorMessage(updateProfile);
      setTimeout(() => {
        setErrorMessage("");
        updateloadData();
      }, 2000);
    } catch (error) {
      console.error("Error fetching data:", error, myHeaders, body);
      setErrorMessage(error.responseJSON.message[0]);
      // updateloadData();

      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
    }
  };

  const updateloadData = async () => {
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",

      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][0]["profile_id"],
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     `/V1/getUserProfile/lastupdated/0000000000/userId/${userId}`,
      //     "GET",
      //     myHeaders
      //   ),
      // ]);
      const response = await getUserProfile(userId);

      if (!response.success) {
        handleAuthFailLogout();
      }

      localStorage.setItem("updateMyProfile", JSON.stringify(response));
      if (response.statusCode === 200) {
        navigate("ProfileScreen");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // window.addEventListener("keydown", AddProfileKeyHandler);

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "LiveEvents":
        navigate("LiveEventsScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  const handleRightButton = () => {
    setStateName((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
    }));
    MenuScreen.SetFocus(true);
  };

  useEffect(() => {
    if (shouldCloseMenu) {
      window.addEventListener("keydown", AddProfileKeyHandler);
    }
    return () => {
      window.removeEventListener("keydown", AddProfileKeyHandler);
    };
  }, [selectedIndex, shouldCloseMenu, keyboardOpen, isBackButtonSelected]);

  useEffect(() => {
    // Focus on avatars
    if (selectedIndex >= 0 && selectedIndex < myprofile.length) {
      setStateName((prevState) => ({
        ...prevState,
        isUserInputBoxSelected: false,
        isToggleButtonSelected: false,
        isAddButton: false,
        isBackButtonSelected: false,
      }));
      if (avatarRefs.current[selectedIndex]) {
        avatarRefs.current[selectedIndex].focus();
      }
    }
    // Navigate to input field, skipping toggle button
    else if (selectedIndex === myprofile.length) {
      setStateName((prevState) => ({
        ...prevState,
        isUserInputBoxSelected: true,
        isToggleButtonSelected: false,
        isAddButton: false,
        isBackButtonSelected: false,
      }));
      if (inputRef.current) inputRef.current.focus();
    }
    // Skip toggle button focus, directly to Add button
    else if (selectedIndex === myprofile.length + 1) {
      setStateName((prevState) => ({
        ...prevState,
        isUserInputBoxSelected: false,
        isToggleButtonSelected: true,
        isAddButton: false,
        isBackButtonSelected: false,
      }));
      inputRef.current.blur();
      if (toggleRef?.current) {
        toggleRef.current.focus();
      }
    } else if (selectedIndex === myprofile.length + 2) {
      setStateName((prevState) => ({
        ...prevState,
        isUserInputBoxSelected: false,
        isToggleButtonSelected: false,
        isAddButton: true,
        isBackButtonSelected: false,
      }));
      toggleRef.current.blur();
      inputRef.current.blur();
      if (buttonRef?.current) {
        buttonRef.current.focus();
      }
    }
  }, [selectedIndex, myprofile.length]);

  const styles = {
    container: {
      backgroundImage: `url(${solidbackgroundimg})`,
      display: "flex",
      flexDirection: "column",
      // alignItems: "center",
      backgroundColor: "#000",
      color: "#fff",
      height: "100vh",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      // justifyContent: "center",
    },
    title: {
      fontWeight: 500,
      fontSize: "2rem",
      marginBottom: "120px",
      color: "rgba(255, 255, 255, 1)",
    },
    avatarSelection: {
      display: "grid",
      gridTemplateColumns: "repeat(5, 1fr)",
      gap: "35px",
      marginBottom: "20px",
      margin: "0px",
      padding: "0px",
      boxSizing: "border-box",
    },
    avatar: {
      width: "141px",
      height: "141px",
      borderRadius: "10px",
      cursor: "pointer",
      outline: "none",
      objectFit: "cover",
    },
    avatarFocused: {
      border: "4px solid rgba(255, 255, 255, 1)",
    },
    nameInput: {
      outline: "none",
      width: "30.83vw",
      fontSize: "1.3rem",
      padding: "16px 8px 16px 8px",
      marginBottom: "25px",
      borderRadius: "10px",
      border: "1px solid rgb(255, 255, 255)",
      backgroundColor: "#0E1653",
      // backgroundColor: "rgb(51, 51, 51)",
      color: "rgb(255, 255, 255)",
      height: "6vh",
      border: isUserInputBoxSelected
        ? "4px solid #fff"
        : "0px solid transparent",
    },
    kidsText: {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
    },
    kidsProfile: {
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
      position: "relative",
      width: "30.34vw",
      // left: "8rem",
      // flexDirection: 'column',
      // width: "60vh",
      margin: "0 auto",
      justifyContent: "space-between",
    },
    kidsProfileLabel: {
      marginRight: "10px",
      fontSize: "16px",
      color: "rgba(255, 255, 255, 1)",
      fontWeight: "400",
      marginBottom: "10px",
    },
    updateButton: {
      padding: "10px 20px",
      border: "none",
      borderRadius: "16px",
      backgroundColor: "#ff6f00",
      color: "#fff",
      cursor: "pointer",
    },
    updateButtonHover: {
      backgroundColor: "#e65c00",
    },
    kidsvideos: {
      // right: "9.5vh",
      position: "relative",
      // top: "3vh",
      fontSize: "14px",
      fontWeight: "400",
      color: "rgba(127, 127, 127, 1)",
    },
    selectedIcon: {
      position: "absolute",
      bottom: "0px",
      right: "-10px",
      width: "40px",
      height: "40px",
    },
    toggleContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
    },
    toggleSwitch: {
      position: "relative",
      display: "inline-block",
      width: "60px",
      height: "30px",
    },
    slider: {
      position: "absolute",
      cursor: "pointer",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#ccc",
      transition: ".4s",
      borderRadius: "34px",
    },
    sliderFocused: {
      boxShadow: "0 0 0 3px rgba(236, 0, 140, 0.5)",
    },
    sliderBefore: {
      position: "absolute",
      content: '""',
      height: "22px",
      width: "22px",
      left: "4px",
      bottom: "4px",
      backgroundColor: "white",
      transition: ".4s",
      borderRadius: "50%",
    },
    sliderChecked: {
      backgroundColor: "#EC008C",
    },
    sliderCheckedBefore: {
      transform: "translateX(26px)",
    },
    profileCard: {
      backgroundColor: "#0E1653",
      borderRadius: "1rem",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // border: "2px solid white",
      width: "151px",
      height: "151px",
      padding: "0px",
      margin: "0px",
      backgroundSize: "cover",
    },
  };

  if (screen === "DeleteProfile") {
    window.removeEventListener("keydown", AddProfileKeyHandler);
    return <DeleteProfile navigate={navigateToScreen} />;
  } else if (screen === "UpdateProfile") {
    window.removeEventListener("keydown", AddProfileKeyHandler);
    return <UpdateProfile navigate={navigateToScreen} />;
  } else if (screen === "EditProfile") {
    window.removeEventListener("keydown", AddProfileKeyHandler);
    return <EditProfile navigate={navigateToScreen} />;
  }

  return screen === "MyProfile" ? (
    <>
      {window.removeEventListener("keydown", AddProfileKeyHandler)}
      <MyProfile navigate={navigateToScreen} />
    </>
  ) : (
    <div style={styles.container}>
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
        `}
      </style>
      <div style={{ position: "absolute" }}>
        <Wrapper
          as="button"
          ref={backButtonRef}
          style={{
            backgroundColor: "transparent",
            border: "none",
            marginLeft: "6rem",
            borderRadius: "1rem",
            aspectRatio: "1/1",
            cursor: "pointer",
            position: "relative",
            top: "4rem",
            zIndex: "1",
            // left: "6rem",
            outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
          }}
          // onMouseEnter={() => {
          //   setStateName(prev => ({...prev, isBackButtonSelected: true}));
          //   setSelectedIndex(-1); // Deselect everything else
          // }}
          onClick={(e) => {
            handleBackButton();
            // handleBack();
            // handleClick(null, -2);
          }}
          onMouseEnter={() => {
            setStateName((prevState) => ({
              ...prevState,
              isBackButtonSelected: true,
            }));
            setSelectedIndex(-1);
            if(backButtonRef.current) backButtonRef.current.focus();
          }}
        >
          <img src={backIcon} width={50} height={50} />
        </Wrapper>
      </div>
      <div
        style={{
          position: "fixed",
          textAlign: "center",
          margin: "auto",
          padding: "0px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          top: "-4.9%",
          gap: "15px",
          justifyContent: "center",
          alignItems: "center",
          left: "28%",
          top: "-5%",
        }}
      >
        {console.log("myprofile", myprofile)}
        <h1 style={styles.title}>
          <Translate langKey={"Add-Profile"} />
        </h1>
        <div style={styles.avatarSelection}>
          {myprofile.map((profile, index) => (
            <Wrapper
              key={index}
              style={{
                position: "relative",
                boxSizing: "border-box",
                borderRadius: "1rem",
                outline: "none",
              }}
              onClick={() => {
                setSelectedIndex(index);
                setIsAvatarSelected(true);
                setErrorMessage(""); // Clear error message on selection
                localStorage.setItem(
                  "selectedAddProfile",
                  JSON.stringify(profile)
                );
                avatarSeclection(index);
              }}
              onMouseEnter={() => {
                setStateName((prevState) => ({
                ...prevState,
                isBackButtonSelected: false,
              }));
                setSelectedIndex(index);
              }}
            >
              <img
                src={profile.url}
                alt="Avatar"
                style={{
                  ...styles.avatar,
                  ...(selectedIndex === index ? styles.avatarFocused : {}),
                  ...styles.profileCard,
                }}
                tabIndex={0}
                ref={(el) => (avatarRefs.current[index] = el)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setSelectedIndex(index);
                    setIsAvatarSelected(true);
                    setErrorMessage(""); // Clear error message on selection
                    localStorage.setItem(
                      "selectedAddProfile",
                      JSON.stringify(profile)
                    );
                  }
                }}
              />
              {confirmedSelection === index && (
                <img
                  src={selectedIcon}
                  alt="Selected"
                  style={styles.selectedIcon}
                />
              )}
            </Wrapper>
          ))}
        </div>
        <div style={{ position: "relative", top: "4vh" }}>
           <style>
            {`
            input::placeholder {
              color: rgba(237, 237, 237, 1);
              font-size: 18px;
              font-weight: 400;
            }

             .error-message {
              color: white;
            font-size: 30px;
            padding: 0;
            position: absolute;
            left: 50%;
            top: 90%;
            transform: translateX(-50%);
            bottom: 2rem; /* Adjust as needed */
            width: 80vw;
            text-align: center;
            margin: 0;
            z-index: 10;
          }

          img:focus {
            outline: none;
          }
            `}
          </style>
          <input
            type="text"
            style={styles.nameInput}
            maxLength={30}
            // placeholder="Enter your name"
            placeholder={`${getTranslation("placeholder-profile")}`}
            value={name}
            ref={inputRef}
            onChange={handleNameChange}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            readOnly={!keyboardOpen}
            onMouseEnter={() => {
              setStateName((prevState) => ({
                ...prevState,
                isBackButtonSelected: false,
              }));
              setSelectedIndex(myprofile.length);
            }}
            onClick={() => {
                setKeyboardOpen(true);
                inputRef.current.focus();
            }}
            onKeyDown={(e) => {
              if ((e.keyCode === 37 || e.keyCode === 39) && keyboardOpen) {
                e.stopPropagation();
                return;
              }
              if (e.keyCode === 13) {
                if (!keyboardOpen) {
                    setKeyboardOpen(true);
                } else {
                    e.stopPropagation();
                    setSelectedIndex(myprofile.length + 1);
                    e.target.blur();
                    setKeyboardOpen(false); 
                }
                return;
              }
              if (!keyboardOpen) { e.preventDefault(); return; }
            }}

            // WIll check
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //   inputRef.current.blur();
            //   }
            // }}
          />
          {/* <div style={styles.kidsProfile}>
            <div style={styles.kidsText}>
              <label
                style={{ ...styles.kidsProfileLabel, paddingBottom: "10" }}
              >
                <Translate langKey={"Kid’sprofile?"} />
              </label>
              <span style={styles.kidsvideos}>
                <Translate langKey={"Onlyshowkid-friendlyvideos"} />
              </span>
            </div>
            <div>
              <ToggleSwitch
                focused={selectedIndex === myprofile.length + 1}
                isChecked={isKidsProfile}
                onChange={() => setIsKidsProfile((prev) => !prev)}
                ref={toggleRef}
              />
            </div>
          </div> */}
          <div style={styles.kidsProfile}>
            <div style={styles.kidsText}>
              <label style={styles.kidsProfileLabel}>
                <Translate langKey={"Kid’sprofile?"} />
              </label>
              <span style={styles.kidsvideos}>
                <Translate langKey={"Onlyshowkid-friendlyvideos"} />
              </span>
            </div>
            <div
              style={{
                position: "relative",
                top: "0px",
                boxShadow: isToggleButtonSelected
                  ? "0 0 0 20px rgba(0, 123, 255, 0.15)"
                  : "none",
                borderRadius: "100%",
                padding: "5px",
              }}
              onMouseEnter={() => {
                setStateName((prevState) => ({
                ...prevState,
                isBackButtonSelected: false,
              }));
                setSelectedIndex(myprofile.length + 1);
              }}
            >
              <ToggleSwitch
                focused={isToggleButtonSelected}
                isChecked={isKidsProfile}
                onChange={() => setIsKidsProfile((prev) => !prev)}
                ref={toggleRef}
              />
            </div>
          </div>
        </div>
        <CustomButton
          navigateTo="/login"
          fontSize="24px"
          defaultSelected={isAddButton}
          // width="34vw"
          height="6.2vh"
          top="6vh"
          left="0"
          position="relative"
          onClick={handleOk}
          onKeyDown={AddProfileKeyHandler}
          ref={buttonRef}
          onMouseEnter={() => {
            setStateName((prevState) => ({
                ...prevState,
                isBackButtonSelected: false,
              }));
            setSelectedIndex(myprofile.length + 2);
          }}
          style={{
            opacity: isAddButtonVisible ? 1 : 0.5,
            pointerEvents: isAddButtonVisible ? "auto" : "none",
            width: "30.83vw",
            ...(selectedIndex === myprofile.length + 10),
          }}
        >
          <Translate langKey={"Add-Profile"} />
          {/* <Translate langKey={'Add'} /> */}
        </CustomButton>
      </div>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      <div style={{ position: "absolute" }}>
        <MenuScreen
          navigate={navigateToScreen}
          handleMenuselection={handleMenuselection}
          shouldCloseMenu={shouldCloseMenu}
          handleRightButton={handleRightButton}
          isLogedIn={isLogedIn}
          appNavigate={navigate}
          handleLogout={handleLogout}
          handleExit={handleExit}
        />
      </div>
      <div style={{ position: "absolute" }}>
        <ModalScreen
          shouldShowError={shouldShowModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div>
      {/* <div
        style={{
          position: "absolute",
        }}
      >
        <AuthFailModal
          shouldShowError={shouldShowAuthModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div> */}
    </div>
  );
};

export default AddProfile;
